import { render } from "./ShippingPage.vue?vue&type=template&id=42e355fe"
const script = {}

import exportComponent from "/var/www/levsha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__